export class RaycastingFlags {
    
    value: number;

    constructor() {

        this.value = 0;

    }

}